import logomark from '../../assets/logomark.png';

// Footer réorganisé : ancre de marque à gauche, Légal + Contact à droite,
// ligne copyright en pied. Fond primary-950 (nuit) — socle de la page.
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-950 border-t border-white/10 pt-16 pb-8 font-sans">
      <div className="container mx-auto px-6">
        <div className="grid gap-12 md:grid-cols-[1.6fr_1fr_1fr] mb-14">

          {/* Ancre de marque */}
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5 mb-5">
              <span className="w-10 h-10 rounded-full bg-white flex items-center justify-center shadow-soft">
                <img src={logomark} alt="MyEduCycle" className="w-7 h-7 object-contain" />
              </span>
              <span className="font-display font-bold text-xl text-white">MyEduCycle</span>
            </div>
            <p className="text-sky-faint text-sm leading-relaxed">
              Le suivi du soutien scolaire à domicile, clair pour les parents et simple pour les répétiteurs.
            </p>
          </div>

          {/* Légal */}
          <div>
            <h4 className="font-display font-bold text-lg text-white mb-6">Légal</h4>
            <ul className="space-y-3 text-sm">
              <li><button type="button" className="text-sky-faint hover:text-white transition-colors duration-200">Conditions Générales</button></li>
              <li><button type="button" className="text-sky-faint hover:text-white transition-colors duration-200">Politique de Confidentialité</button></li>
              <li><button type="button" className="text-sky-faint hover:text-white transition-colors duration-200">Mentions Légales</button></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display font-bold text-lg text-white mb-6">Contact</h4>
            <a
              href="mailto:support@myeducycle.com"
              className="text-sky-faint hover:text-white text-sm transition-colors duration-200 block mb-4"
            >
              support@myeducycle.com
            </a>
            <button className="bg-accent hover:bg-accent-hover text-primary font-semibold px-6 py-2 rounded-lg text-sm transition-colors duration-200">
              Nous contacter
            </button>
          </div>
        </div>

        <div className="border-t border-white/10 pt-8">
          <p className="text-sky-faint text-xs">
            © {currentYear} MyEduCycle. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
